module.exports = __webpack_public_path__ + "static/media/shopping_seaplaneport_marker.84ea3550.svg";